import React from "react";
import { useClassPrepend } from "../../../hook/ui/common/className/useClassPrepend";
import { UnstyledButton } from "../../unstyled/button/UnstyledButton";
import { InlineLoader } from "../../../styled";
import "./button.css";
const Button = ({
  classPrepend = "styled",
  className = "",
  onClick,
  styleType = "default",
  type = "button",
  disabled = false,
  loading = false,
  children
}) => {
  const [getClassName, getClassNameWithGlobal, getClassNameValue] = useClassPrepend(classPrepend);
  const styleTypeClassNameMap = {
    "default": getClassNameValue("button-default"),
    "primary": getClassNameValue("button-primary"),
    "submit": getClassNameValue("button-submit"),
    "secondary": getClassNameValue("button-secondary")
  };
  const newClassName = `${className} ${styleTypeClassNameMap[styleType]} ${loading ? getClassNameValue("button-loading") : ""}`;
  return /*#__PURE__*/React.createElement(UnstyledButton, {
    classPrepend: classPrepend,
    className: newClassName,
    onClick: onClick,
    type: type,
    disabled: disabled || loading
  }, /*#__PURE__*/React.createElement(InlineLoader, {
    showLoader: loading
  }), children);
};
export { Button };